import { type GetResponse } from '@commutifi-fe/interfaces';
import { type InfiniteData } from 'api/reactQuery';
export const calculatePageOffset = (page: number | undefined, pageSize = 15) => Math.max((page || 1) - 1, 0) * pageSize;
export const calculateCurrentPage = (offset = 0, pageSize = 15) => offset / pageSize + 1;

/**
 * Returns the single record from an infinite paginated response when exactly
 * one result exists in total, or undefined otherwise.
 * Relies on totalCount from metadata (not records.length) to correctly handle
 * cases where the first page has one record but more pages exist.
 */
export function getSingleAutoSelectRecord<T>(data: InfiniteData<GetResponse<T>>): T | undefined {
  const totalCount = data.pages[0]?._metadata?.totalCount;
  const records = data.pages.flatMap(page => page.records);
  return totalCount === 1 && records.length === 1 ? records[0] : undefined;
}